import { useEffect, useRef, type ReactNode } from "react";
import { useSessionContext } from "@contexts";
import {
    identityKeyForSession,
    identifyPosthogUser,
    resetPosthogOnLogout
} from "./posthog-identify";

/**
 * Syncs PostHog from `SessionData`.
 * When the session identity key changes: if logged in, calls `identifyPosthogUser`;
 * if transitioning to logged out, calls `resetPosthogOnLogout`.
 */
export function PosthogIdentifyProvider({ children }: { children: ReactNode }) {
    const { session } = useSessionContext();
    const identityKey = identityKeyForSession(session);
    const prevKeyRef = useRef<string | null>(null);

    useEffect(() => {
        const prev = prevKeyRef.current;
        prevKeyRef.current = identityKey;

        if (prev !== null && prev !== `anon` && identityKey === `anon`) {
            resetPosthogOnLogout();
            return;
        }

        if (identityKey !== `anon` && session) {
            identifyPosthogUser(session);
        }
    }, [identityKey]);

    return children;
}
